module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_vm._v("\n        Claims Management Dashboard\n    ")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-202ac650", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-202ac650"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/portalhome/claimsmanagement/index.vue.html
// module id = 583
// module chunks = 0